import React, { useEffect } from 'react';
import './SpecialDayOffCalendar.scss';
import { useTranslation } from 'react-i18next';
import { getNumberOfDays } from '../../helpers/dateHelpers';
import {
  checkConsecutiveDays,
  getBlockedDayCalendarClass,
  getSelectedDays
} from './SpecialDayOffHelper';

export const SpecialDayOffCalendar = ({
  sdoMonthYear,
  sdoBlockDates,
  requestedDates = [],
  setRequestBtnDisabled,
  setSelectedDays,
  setIsSdoMonthDateSelected,
  setIsBlockedDateSelected,
  blockedDates
}) => {
  const { t } = useTranslation();

  useEffect(() => {
    if (!sdoBlockDates) {
      return;
    }
    const arrDateCalender = getNumberOfDays(
      sdoBlockDates.start,
      sdoBlockDates.end
    );
    const calendarContainer = document.querySelector(
      '.sdo__calendar__container'
    );
    const calBlockDays: any = document.querySelectorAll('.sdo__calendar__day');
    if (calendarContainer && !calBlockDays.length) {
      arrDateCalender.forEach((day) => {
        const currDate = new Date(day + ' 00:00');
        const date = currDate.getDate();
        if (day === arrDateCalender[0]) {
          for (let weekCount = 0; weekCount < 7; weekCount++) {
            if (currDate.getDay() !== weekCount) {
              calendarContainer.insertAdjacentHTML('beforeend', `<div></div>`);
            } else {
              break;
            }
          }
        }
        calendarContainer.insertAdjacentHTML(
          'beforeend',
          `<div class="sdo__calendar__day" data-value=${day}>${date}</div>`
        );
      });

      document
        .querySelectorAll('.sdo__calendar__container .sdo__calendar__day')
        .forEach((day) => {
          day.addEventListener('click', (event) => {
            setIsBlockedDateSelected(false);
            const selectedDate = event.target as Element;
            if(!isSelectedDayBlockedDate(selectedDate)) {
              setIsBlockedDateSelected(true);
              return;
            }
            const calBlockDays: any = document.querySelectorAll(
              '.sdo__calendar__day--selected'
            );
            let addFlag = true;

            // remove selection if user wants to remove a selection of days
            if (
              selectedDate?.classList?.contains('sdo__calendar__day--selected')
            ) {
              calBlockDays.forEach((blockDay) => {
                blockDay.classList?.remove('sdo__calendar__day--selected');
                setRequestBtnDisabled(true);
              });
              addFlag = false;
            }
            // don't allow selection of more than 4 days
            if (addFlag && calBlockDays && calBlockDays.length <= 3) {
              if (isSelectedDayBlockedDate(selectedDate)) {
                selectedDate?.classList?.add('sdo__calendar__day--selected');
                setRequestBtnDisabled(false);
              } 
            } else {
              calBlockDays.forEach((calBlockDay) => {
                if (
                  calBlockDay.classList.contains('sdo__calendar__day--selected')
                ) {
                  calBlockDay.classList.remove('sdo__calendar__day--selected');
                  setRequestBtnDisabled(true);
                  setIsSdoMonthDateSelected(true);
                }
              });
            }
            selectDatesAuto();
            setSelectedDays(getSelectedDays().slice());
          });
        });

      loadSelectedCalendarDates();
      loadBlockedCalendarDates();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sdoBlockDates]);

  const checkSelectedDaysHaveBlockedDays = (selectedDaysArray) => {
    if (!blockedDates && !blockedDates.length) return false;

    let checkFlag = false;
    for (let selectedDay of selectedDaysArray) {
      const selectedDateTime = new Date(selectedDay).getTime();

      for (let blockedDate of blockedDates) {
        const blockedDateStartTime = new Date(
          blockedDate?.start_date
        ).getTime();
        const blockedDateEndTime = new Date(blockedDate?.end_date).getTime();
        if (
          selectedDateTime >= blockedDateStartTime &&
          selectedDateTime <= blockedDateEndTime
        ) {
          checkFlag = true;
          break;
        }
      }
    }
    return checkFlag;
  };

  const selectDatesAuto = () => {
    const selectedBlockDay: any = [];
    const calBlockDays: any = document.querySelectorAll('.sdo__calendar__day');

    if (calBlockDays) {
      calBlockDays.forEach((blockDay) => {
        if (
          blockDay &&
          blockDay.classList.contains('sdo__calendar__day--selected')
        ) {
          selectedBlockDay.push(blockDay);
        }
      });
      if (selectedBlockDay && selectedBlockDay.length === 2) {
        let firstDate = '';
        let lastDate = '';

        if (
          new Date(selectedBlockDay[0].dataset.value).getTime() <
          new Date(selectedBlockDay[1].dataset.value).getTime()
        ) {
          firstDate = selectedBlockDay[0].dataset.value;
          lastDate =
            selectedBlockDay[selectedBlockDay.length - 1].dataset.value;
        } else {
          firstDate =
            selectedBlockDay[selectedBlockDay.length - 1].dataset.value;
          lastDate = selectedBlockDay[0].dataset.value;
        }
        let totalBlockDaysSelected = getNumberOfDays(
          new Date(firstDate),
          new Date(lastDate)
        );
        if (checkSelectedDaysHaveBlockedDays(totalBlockDaysSelected)) {
          calBlockDays.forEach((calBlockDay) => {
            if (
              calBlockDay.classList.contains('sdo__calendar__day--selected')
            ) {
              calBlockDay.classList.remove('sdo__calendar__day--selected');
              setRequestBtnDisabled(true);
            }
          });
          return;
        }
        if (totalBlockDaysSelected.length <= 4) {
          totalBlockDaysSelected.forEach((blockDay) => {
            if (blockDay) {
              calBlockDays.forEach((calBlockDay) => {
                if (calBlockDay && calBlockDay.dataset.value === blockDay) {
                  if (
                    !calBlockDay.classList.contains(
                      'sdo__calendar__day--selected'
                    )
                  ) {
                    calBlockDay.classList.add('sdo__calendar__day--selected');
                    setRequestBtnDisabled(false);
                  }
                }
              });
            }
          });
        } else {
          // remove class sdo__calendar__day--selected
          totalBlockDaysSelected.forEach((blockDay) => {
            if (blockDay) {
              calBlockDays.forEach((calBlockDay) => {
                if (calBlockDay && calBlockDay.dataset.value === blockDay) {
                  if (
                    calBlockDay.classList.contains(
                      'sdo__calendar__day--selected'
                    )
                  ) {
                    calBlockDay.classList.remove(
                      'sdo__calendar__day--selected'
                    );
                    setRequestBtnDisabled(true);
                    setIsSdoMonthDateSelected(true);
                  }
                }
              });
            }
          });
        }
      } else if (selectedBlockDay.length > 1) {
        if (!checkConsecutiveDays(selectedBlockDay)) {
          calBlockDays.forEach((calBlockDay) => {
            if (
              calBlockDay.classList.contains('sdo__calendar__day--selected')
            ) {
              calBlockDay.classList.remove('sdo__calendar__day--selected');
              setRequestBtnDisabled(true);
              setIsSdoMonthDateSelected(true);
            }
          });
        }
      }
    }
  };

  const isSelectedDayBlockedDate = (selectedDate) => {
    if (!blockedDates && !blockedDates.length) return true;
    let checkFlag = true;
    const selectedDateTime = new Date(selectedDate.dataset.value).getTime();
    blockedDates.forEach((blockedDate) => {
      const blockedDateStartTime = new Date(blockedDate?.start_date).getTime();
      const blockedDateEndTime = new Date(blockedDate?.end_date).getTime();
      if (
        selectedDateTime >= blockedDateStartTime &&
        selectedDateTime <= blockedDateEndTime
      ) {
        checkFlag = false;
      }
    });
    return checkFlag;
  };

  const loadBlockedCalendarDates = () => {
    if (!blockedDates && !blockedDates.length) return;

    const calBlockDays: any = document.querySelectorAll('.sdo__calendar__day');
    if (!calBlockDays && !calBlockDays.length) return;

    calBlockDays.forEach((blockDay) => {
      if (blockDay) {
        const blockDayTime = new Date(blockDay.dataset.value).getTime();
        for (let blockedDate of blockedDates) {
          const blockedDateStartTime = new Date(
            blockedDate?.start_date
          ).getTime();
          const blockedDateEndTime = new Date(blockedDate?.end_date).getTime();
          if (
            blockDayTime >= blockedDateStartTime &&
            blockDayTime <= blockedDateEndTime
          ) {
            blockDay.classList.add(
              getBlockedDayCalendarClass(blockedDate?.code)
            );
            if (blockedDate.code === 'Embargo') break;
          } else if (blockDayTime < blockedDateStartTime) {
            break;
          }
        }
      }
    });
  };

  const loadSelectedCalendarDates = () => {
    const dateItems = document.querySelectorAll(
      '.sdo__calendar__container .sdo__calendar__day'
    );
    if (dateItems && dateItems.length > 0) {
      if (requestedDates.length === 0) {
        return;
      }
      let selectedTimes = requestedDates.map((date) =>
        new Date(date).getTime()
      );
      dateItems.forEach((dateElement) => {
        const selectedDateElement = dateElement as Element;
        let selectedDateTime = new Date(
          `${selectedDateElement.getAttribute('data-value')}`
        ).getTime();

        if (
          selectedTimes.length > 0 &&
          selectedTimes.includes(selectedDateTime)
        ) {
          if (
            !selectedDateElement.classList.contains(
              'sdo__calendar__day--selected'
            )
          ) {
            selectedDateElement.classList?.add('sdo__calendar__day--selected');
          }
        }
      });
    }
  };

  return (
    <div className="sdo__calendar">
      <div className="sdo__calendar__block-month-details">
        <span className="sdo__calendar__block-month-name">
          {sdoMonthYear ?? 'N/A'}{' '}
        </span>
        <span className="sdo__calendar__block-month-days">
          ({sdoBlockDates.numbersOfDays ? sdoBlockDates.numbersOfDays : 'N/A'}
          {t('specialDayOff.specialDayOffRequestForm.days')})
        </span>
      </div>
      <div className="sdo__calendar__container">
        <div className="sdo__calendar__week-header">S</div>
        <div className="sdo__calendar__week-header">M</div>
        <div className="sdo__calendar__week-header">T</div>
        <div className="sdo__calendar__week-header">W</div>
        <div className="sdo__calendar__week-header">T</div>
        <div className="sdo__calendar__week-header">F</div>
        <div className="sdo__calendar__week-header">S</div>
      </div>
    </div>
  );
};
